import { AxiosResponseHeaders } from 'axios';
import { Nullable } from '@dxb-web-ui-framework/common/types';
import { Translation, TranslationResponseDTO } from '../entities';

const translationsResponseDTOToTranslationsAdapter = (
  data: TranslationResponseDTO,
  headers?: AxiosResponseHeaders,
): Nullable<Translation[]> => {
  if (!data.body) {
    throw new Error('Error');
  }

  const translationsWithValues = data.body.filter(translation => translation.value);

  return translationsWithValues.map(
    translation => new Translation(translation.id, translation.value, translation.localValue),
  );
};

export { translationsResponseDTOToTranslationsAdapter };
